import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { YazidanResmeComponent } from "./yazidan-resme/yazidan-resme.component";
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { IEk } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';

@Component({
    selector: 'fiko-yapay-zeka',
    templateUrl: './yapay-zeka.component.html',
    styleUrl: './yapay-zeka.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        YazidanResmeComponent
    ]
})
export class YapayZekaComponent extends FikoYTKokBilesenComponent {

  /** */
  private _ek: IEk | any;
  public get ek(): IEk | any {
    return this._ek;
  }
  @Input() public set ek(v: IEk | any) {
    this._ek = v;
    this.ekChange.emit(v);
    this.CD.detectChanges();
  }
  @Output() ekChange: EventEmitter<IEk> = new EventEmitter<IEk>();


  async tiklandiSiniflandir(img: any) {
    //@ts-ignore
    // tf.ENV.set('WEBGL_PACK', false)
    // const mobilenetModel = await mobilenet.load()
    // const MobileNetSiniflar = await mobilenetModel.classify(img)


    // const cocoModel = await cocoSsd.load();
    // const cocoSonuc = await cocoModel.detect(img, 20, 0);
    // console.log(cocoSonuc)

    // nsfwjs.load('https://cdn.jsdelivr.net/gh/infinitered/nsfwjs@2.4.1/example/nsfw_demo/public/quant_nsfw_mobilenet/').then((model: any) => {
    //   model.classify(img).then((predictions: any) => {
    //     console.log(predictions)
    //     this.sonuc = [...MobileNetSiniflar, ...cocoSonuc, ...predictions];
    //     this.CD.detectChanges();
    //   })
    // })

  }
}
